export default {
	dbName: "openrouteAdmin",
	versionNumber: 1,
	schema: {
		users: "&,access_token,added_on,additional_info,code_recover_date,code_recover_pass,company_id,company_name,created_at,email,expire_token,id,identification,lastname,name,permissions,role_id,role_name,status,status_id,typology_id,typology_name,uid,update_on,username",
		routing: "&",
		app_setting: "&,color",
		preferences: "&",
		match_filter: "&",
	},
};
